import store from 'store'
import { supportedCurrencies } from 'plugins/wsc-shop'

const price = (value) => {
  if (!store.state.shop.shop) return ''

  const shopCurrency = supportedCurrencies.find(option => option.value === store.state.shop.shop.currency)

  // divide the value by 100 to convert from cent to currency
  let formatedPrice = (value / 100).toLocaleString(shopCurrency.local, {
    minimumFractionDigits: 2
  })

  if (shopCurrency) {
    return `${shopCurrency.short} ${formatedPrice}`
  }
  return formatedPrice
}

export default price



// WEBPACK FOOTER //
// ./client/plugins/i18n-formaters/price.js